import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../api/apiClient';
import { usePreloaderStore, useConfirmationModalStore } from '../../../../../stores';
import { PlusIcon, EditPencilIcon, TrashIcon, CoinIcon } from '../../../model/icons';
import { taskPhase, formatDt } from './ttUtils';
import TaskModal from './TaskModal';

// Панель «Редактирование»: список заданий смены + CRUD, публикация/архив.
export default function EditPanel({ smenaId, gameStatus, tasks, onChanged }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const { open: openConfirm } = useConfirmationModalStore();
    const [modal, setModal] = useState(null); // {task} | {create:true}

    const finished = gameStatus === 'FINISHED';
    const sorted = [...tasks].sort((a, b) => String(a.availableFrom || '').localeCompare(String(b.availableFrom || '')));

    const remove = (task) => openConfirm(
        <div className="confirm-msg">
            <b>Удалить задание «{task.title}»?</b>
            <p>Задание будет удалено вместе с историей сдач. Действие необратимо.</p>
        </div>,
        async () => {
            show();
            try {
                await apiClient.delete(`/api/team-tasks/admin/delete?id=${task.id}`);
                enqueueSnackbar('Задание удалено', { variant: 'success' });
                onChanged();
            } catch (e) { enqueueSnackbar(e.response?.data?.message || 'Ошибка при удалении', { variant: 'error' }); }
            finally { hide(); }
        },
        { confirmText: 'Удалить' }
    );

    return (
        <div className="bt-panel">
            <section className="fr-card">
                <div className="ev-head">
                    <h2>Задания <span className="fr-cnt">{tasks.length}</span></h2>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setModal({ create: true })}
                        disabled={finished}
                        title={finished ? 'Игра завершена — создание заданий недоступно' : undefined}
                    >
                        <span className="ic"><PlusIcon /></span>Создать задание
                    </button>
                </div>

                {sorted.length > 0 ? (
                    <div className="tt-list">
                        {sorted.map(task => {
                            const phase = taskPhase(task);
                            return (
                                <div key={task.id} className="tt-task">
                                    <div className="tt-info">
                                        <div className="tt-top">
                                            <span className="tt-title">{task.title}</span>
                                            <span className={`tt-status ${phase.tone}`}>{phase.label}</span>
                                        </div>
                                        {task.description && <div className="tt-desc">{task.description}</div>}
                                        <div className="tt-meta">
                                            <span className="tt-tag pts" title="Баллы каждому игроку команды">Каждому участнику <b>{task.rewardBalance}</b> <CoinIcon /></span>
                                            <span className="tt-tag coin" title="Coin Limited на команду (делится поровну)">Coin Limited <b>{task.coinBank}</b> <CoinIcon /></span>
                                            <span className="tt-tag from">с {formatDt(task.availableFrom)}</span>
                                            {task.availableUntil && <span className="tt-tag until">до {formatDt(task.availableUntil)}</span>}
                                        </div>
                                    </div>
                                    <div className="tt-acts">
                                        <button type="button" className="btn btn-ghost btn-sm" onClick={() => setModal({ task })}><span className="ic"><EditPencilIcon /></span>Изменить</button>
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => remove(task)}><span className="ic"><TrashIcon /></span></button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : <div className="bt-empty">Нет заданий — создайте первое</div>}
            </section>

            {modal && (
                <TaskModal task={modal.task} smenaId={smenaId} onSuccess={onChanged} onClose={() => setModal(null)} />
            )}
        </div>
    );
}

EditPanel.propTypes = {
    smenaId: PropTypes.number.isRequired,
    gameStatus: PropTypes.string,
    tasks: PropTypes.array.isRequired,
    onChanged: PropTypes.func.isRequired
};

EditPanel.defaultProps = { gameStatus: null };
